import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectAssetType extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      asset_type: props.asset_type,
      asset_types: props.asset_types,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectAssetType() {
    let debounceTimer;
    const account = this.state.account;
    const asset_type = this.state.asset_type;
    const asset_types = this.state.asset_types;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        asset_type: value,
      });
      if (value) {
        document.getElementById('asset_type_id').value = value.id;
      } else {
        document.getElementById('asset_type_id').value = null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/asset_types/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!asset_type && (!asset_types || asset_types.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ asset_types: options });
        });
      }
    };

    const customOption = (asset_type) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {asset_type["title"]}
            </div>
            {asset_type["badge"] && <div className="ml-auto small">
              {asset_type["badge"]}
            </div>}
          </div>
          {asset_type["description"] && <div className="small select-description">
            {asset_type["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={asset_types}
        placeholder={"Select a asset type..."}
        value={asset_type}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          valueContainer: (base) => ({ ...base, minHeight: '40px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectAssetType()}
      </div>
    );
  }
}

SelectAssetType.propTypes = {
  account: PropTypes.object,
  asset_type: PropTypes.object,
  asset_types: PropTypes.array,
};

export default SelectAssetType;
